function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg063Iran(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.006,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6DA544"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.337,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44.522,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.043,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.565,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.087,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.609,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.13,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.652,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.174,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.696,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.217,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.739,
    y: 155.826,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 30.049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.522,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.043,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.565,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.087,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.609,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.13,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.652,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.174,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.696,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.217,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.739,
    y: 326.678,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 29.492
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M319.746,204.8h-25.679c0.213,2.822,0.333,5.669,0.333,8.534c0,18.986-4.745,37.388-13.018,50.488  c-2.552,4.04-6.841,9.746-12.582,13.595V204.8h-25.6v72.615c-5.74-3.849-10.03-9.553-12.582-13.595  c-8.273-13.099-13.018-31.501-13.018-50.488c0-2.864,0.121-5.712,0.333-8.534h-25.679c-0.165,2.808-0.254,5.652-0.254,8.534  c0,52.636,28.112,93.866,64,93.866s64-41.23,64-93.866C320,210.452,319.911,207.608,319.746,204.8z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg063Iran);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };